(function () {
    const menuBtn  = document.getElementById('menu-open');
    const drawer   = document.getElementById('mobile-drawer');
    const backdrop = document.getElementById('menu-backdrop');

    if (!menuBtn || !drawer || !backdrop) return;

    const DURATION = 0.35;
    const EASE     = 'power2.inOut';
    const panelHistory = [];

    gsap.set(drawer, { x: '-100%' });
    drawer.querySelectorAll('.drawer-panel').forEach(p => {
        gsap.set(p, { x: p.dataset.panel === 'root' ? '0%' : '100%' });
    });

    function openMenu() {
        gsap.to(drawer, { x: '0%', duration: DURATION, ease: EASE });
        backdrop.classList.add('is-visible');
        menuBtn.setAttribute('aria-expanded', 'true');
        menuBtn.setAttribute('aria-label', 'Close menu');
        document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
        gsap.to(drawer, { x: '-100%', duration: DURATION, ease: EASE, onComplete: resetPanels });
        backdrop.classList.remove('is-visible');
        menuBtn.setAttribute('aria-expanded', 'false');
        menuBtn.setAttribute('aria-label', 'Open menu');
        document.body.style.overflow = '';
    }

    function resetPanels() {
        drawer.querySelectorAll('.drawer-panel').forEach(p => {
            p.classList.remove('is-active', 'is-previous');
            gsap.set(p, { x: p.dataset.panel === 'root' ? '0%' : '100%' });
        });
        drawer.querySelector('.drawer-panel[data-panel="root"]').classList.add('is-active');
        panelHistory.length = 0;
    }

    function pushPanel(targetId) {
        const current = drawer.querySelector('.drawer-panel.is-active');
        const target  = drawer.querySelector(`.drawer-panel[data-panel="${targetId}"]`);
        if (!target) return;

        panelHistory.push(current.dataset.panel);
        current.classList.remove('is-active');
        current.classList.add('is-previous');
        target.classList.add('is-active');

        gsap.to(current, { x: '-30%', duration: DURATION, ease: EASE });
        gsap.fromTo(target, { x: '100%' }, { x: '0%', duration: DURATION, ease: EASE });
    }

    function popPanel() {
        if (!panelHistory.length) { closeMenu(); return; }
        const prevId  = panelHistory.pop();
        const current = drawer.querySelector('.drawer-panel.is-active');
        const prev    = drawer.querySelector(`.drawer-panel[data-panel="${prevId}"]`);

        current.classList.remove('is-active');
        prev.classList.remove('is-previous');
        prev.classList.add('is-active');

        gsap.to(current, { x: '100%',  duration: DURATION, ease: EASE });
        gsap.to(prev,    { x: '0%',    duration: DURATION, ease: EASE });
    }

    menuBtn.addEventListener('click', () => {
        menuBtn.getAttribute('aria-expanded') === 'true' ? closeMenu() : openMenu();
    });

    backdrop.addEventListener('click', closeMenu);

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && menuBtn.getAttribute('aria-expanded') === 'true') closeMenu();
    });

    drawer.addEventListener('click', e => {
        const panelLink = e.target.closest('[data-panel-target]');
        if (panelLink) { e.preventDefault(); pushPanel(panelLink.dataset.panelTarget); return; }
        if (e.target.closest('.panel-back')) { popPanel(); return; }

        const toggleBtn = e.target.closest('.level-3-toggle');
        if (toggleBtn) {
            const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
            toggleBtn.setAttribute('aria-expanded', String(!expanded));
            toggleBtn.closest('li').querySelector('ul.links').classList.toggle('is-open');
        }
    });

    // Lock body scroll when predictive search results are open on mobile
    const searchInput = document.getElementById('mm-search-input');
    if (searchInput) {
        function unlockBodyForSearch() {
            if (menuBtn.getAttribute('aria-expanded') !== 'true') {
                document.body.style.overflow = '';
            }
        }
        searchInput.addEventListener('input', function () {
            document.body.style.overflow = this.value ? 'hidden' : '';
        });
        const searchReset = document.querySelector('#mm .predictive-search__reset-button');
        if (searchReset) searchReset.addEventListener('click', unlockBodyForSearch);
        const searchClose = document.getElementById('mm-search-close');
        if (searchClose) searchClose.addEventListener('click', unlockBodyForSearch);
    }
}());